// removed by extract-text-webpack-plugin
module.exports = {"sectionDivider":"SidePanelStyle__sectionDivider___3054s","summaryHeader":"SidePanelStyle__summaryHeader___3Mypa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SidePanel/SidePanelStyle.less
// module id = 1222
// module chunks = 0